import { useId } from "react";
import styles from "./CaseFileBox.module.scss";

/* UI-DESIGN: LB-46 what's in the box. The case file lies open on the table
   with what a host actually gets: invitations, character cards, clue
   drops and the reveal. The reveal is sealed with C's red seal ("open on
   the night", LB-44), the quiet sign that this is a digital pack you buy
   and keep until the party; B's red pencil (the signature device) rings
   the seal and annotates each paper. Everything is real text, in a list,
   in reading order; the papers' sample lines are decorative.
   DRAFT for Taco/Avi: every sample line and pencil note here
   (docs/lightbox/lb43-46/COPY.md). */

/* the seal: a red disc with the words running round it */
const Seal = () => {
  const ring = useId();
  return (
    <svg className={styles.seal} viewBox="0 0 100 100" aria-hidden focusable="false">
      <defs>
        <path id={ring} d="M50 50 m-34 0 a34 34 0 1 1 68 0 a34 34 0 1 1 -68 0" />
      </defs>
      <circle cx="50" cy="50" r="47" className={styles.sealDisc} />
      <circle cx="50" cy="50" r="44" className={styles.sealLip} />
      <circle cx="50" cy="50" r="24" className={styles.sealLip} />
      <text className={styles.sealText}>
        <textPath href={`#${ring}`} startOffset="0" textLength="210" lengthAdjust="spacing">
          OPEN ON THE NIGHT  OPEN ON THE NIGHT  
        </textPath>
      </text>
      <text x="50" y="47" className={styles.sealMid}>SEALED</text>
      <text x="50" y="58" className={styles.sealMid}>NO. 01</text>
    </svg>
  );
};

/* a red grease-pencil ring, two loose passes, drawn round the seal */
const PencilRing = () => (
  <svg className={styles.ring} viewBox="0 0 200 200" aria-hidden focusable="false">
    <path d="M150 34 C 118 10, 52 14, 28 58 C 6 100, 30 168, 98 178 C 160 186, 192 140, 184 92 C 178 58, 156 36, 120 28" />
    <path d="M160 46 C 128 18, 62 22, 38 62 C 18 102, 40 160, 100 170 C 156 176, 184 136, 178 96" className={styles.ringSecond} />
  </svg>
);

const CaseFileBox = () => (
  <div className={styles.file} data-lb-contrast="">
    <span className={styles.tab} aria-hidden />
    <ul className={styles.papers} aria-label="In every case file">
      <li className={`${styles.paper} ${styles.invite}`}>
        <h3 className={styles.kind}>Invitations</h3>
        <p className={styles.sampleDisplay} aria-hidden>You're invited.</p>
        <p className={styles.sample} aria-hidden>Dinner, Saturday at seven. Come as someone else.</p>
        <p className={styles.note}>send a week out</p>
      </li>
      <li className={`${styles.paper} ${styles.character}`}>
        <h3 className={styles.kind}>Character cards</h3>
        <p className={styles.sampleDisplay} aria-hidden>Suspect 04: the butler</p>
        <p className={styles.sample} aria-hidden>Knows where everyone was at nine. Lies about one of them.</p>
        <p className={styles.note}>one per guest</p>
      </li>
      <li className={`${styles.paper} ${styles.clue}`}>
        <h3 className={styles.kind}>Clue drops</h3>
        <p className={styles.sampleDisplay} aria-hidden>Clue 02</p>
        <p className={styles.sample} aria-hidden>A second set of footprints by the cellar door.</p>
        <p className={styles.note}>one each round</p>
      </li>
      <li className={`${styles.paper} ${styles.reveal}`}>
        <h3 className={styles.kind}>The reveal</h3>
        <div className={styles.sealWrap}>
          <Seal />
          <PencilRing />
        </div>
        <p className={styles.note}>only the host opens this</p>
      </li>
    </ul>
  </div>
);

export default CaseFileBox;
